if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.isClubProductInCart = window.__abc.ShopifyCartData.isClubProductInCart;
        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.isBundle = this.getAttribute('is-bundle') === 'true';
        this.clubToggleOn = false;
        if (!this.isBundle) {
          this.variantIdInput.disabled = false;
        }

        this.statusElement = document.createElement('div');
        this.statusElement.className = 'visually-hidden';
        this.statusElement.setAttribute('role', 'status');
        this.statusElement.setAttribute('aria-live', 'polite');
        this.appendChild(this.statusElement);
      }

      get clubToggleOn() {
        return this._clubToggleOn;
      }

      set clubToggleOn(value) {
        this._clubToggleOn = value;
        //console.log('this._clubToggleOn', this._clubToggleOn);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.setAttribute('aria-busy', 'true');
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        this.statusElement.textContent = window.variantStrings.addingToCart;

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        //  console.log('this.clubToggleOn', this.clubToggleOn);
        // console.log();
        if (this.clubToggleOn && !this.isClubProductInCart) {
          const toSend = {};
          toSend['section-id'] = formData.get('section-id');
          toSend['product-id'] = formData.get('product-id');
          toSend['sections'] = formData.get('sections');
          toSend['sections_url'] = formData.get('sections_url');
          toSend['form_type'] = formData.get('form_type');
          toSend['items'] = [];
          if (this.isBundle) {
            const bundleIds = formData.getAll('id[]');
            bundleIds.forEach((id) => {
              toSend['items'].push({
                id: id,
                quantity: formData.get('quantity'),
              });
            });
          } else {
            toSend['items'].push({
              id: formData.get('id'),
              quantity: formData.get('quantity'),
            });
          }
          toSend['items'].push({
            id: window.__abc.clubProduct.variants[0].id,
            quantity: 1,
            selling_plan: window.__abc.clubProduct.selling_plan_groups[0].selling_plans[0].id,
          });

          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(toSend);
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.statusElement.textContent = '';

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            this.statusElement.textContent = window.variantStrings.addedToCart;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              //console.log({ response });
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-busy');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
